import axios from "axios";
const abacusCoreApiBaseUrl = "https://wallet-backend-dev.azurewebsites.net/api/";
const instance = axios.create({
    baseURL: abacusCoreApiBaseUrl,
    // 5 minutes
    timeout: 300000,
    headers: {
        "Access-Control-Allow-Origin": "*"
    }
});
export async function getGoogleToken(userId, storeName) {
    return instance.get("getGoogleWallet?userId=;" + userId + "&store=" + storeName);
}

export function getAppleAPIUrl(userId, storeId) {
    return abacusCoreApiBaseUrl + "getAppleWallet?userId=" + userId + "&storeId=" + storeId;
}
